import React from 'react';
import { DndContext, closestCenter } from '@dnd-kit/core';
import { horizontalListSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import SortableItem from './SortableItem';
import { Col, Row } from 'react-bootstrap';
import { useCookiesContext } from '../../../../contexts/CookiesContext';
import { screenshotUploadInputLabels } from '@revbox/localization';

const ScreenshotsUpload = ({
  onScreenshotsChange,
  screenshotsInputRef,
  croppedScreenshotsPreviews,
  handleRemoveScreenshot,
  handleDragEnd,
  dimensions,
  disabled = false,
  title = 'Screenshots',
  description = '1 min, add up to 4'
}) => {
  const { getLanguageAbbr } = useCookiesContext();
  const lang = getLanguageAbbr();
  const labels = screenshotUploadInputLabels[lang];

  return (
    <div className="setting-item">
      <Row className="g-2 align-items-center">
        <Col md="2">
        <h6>{title}</h6>
        <p>{description}<br />{`${dimensions.width}x${dimensions.height}px`}, JPG/PNG</p>
      </Col>
      <Col md>
        <form className="file-input-form" method="post" encType="multipart/form-data" style={{ opacity: disabled ? 0.5 : 1 }}>
          <div>
            <input
              type="file"
              multiple
              id="screenshots_upload"
              name="screenshots_uploads"
              accept=".png,.jpg,.jpeg"
              onChange={onScreenshotsChange}
              ref={screenshotsInputRef}
              style={{ opacity: 0 }}
              disabled={disabled}
            />
          </div>
          <div className="input-file-preview">
            <label htmlFor="screenshots_upload">{labels.title}</label>
            <p className='vertical-stick'></p>
            <p id="screenshots-input-placeholder">{labels.placeholder}</p>
          </div>
        </form>
        {croppedScreenshotsPreviews.length > 0 && (
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={croppedScreenshotsPreviews}
              strategy={horizontalListSortingStrategy}
            >
              <div className="sortable-list">
                {croppedScreenshotsPreviews.map((preview, index) => (
                  <SortableItem
                    key={`${preview}-${index}`}
                    id={preview}
                    imageSrc={preview}
                    index={index}
                    onRemove={handleRemoveScreenshot}
                  />
                ))}
              </div>
            </SortableContext>
          </DndContext>
        )}
      </Col>
    </Row>
  </div>
)};

export default ScreenshotsUpload;
